const BASE_URL = 'http://localhost:5000'
export default BASE_URL

